module.exports = __webpack_public_path__ + "static/img/zh-Hans.61a631e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/zh-Hans.png
// module id = qDj+
// module chunks = 1